// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ExploreMenu_wrapper__z0Kai","course":"ExploreMenu_course__1__bs","career":"ExploreMenu_career__K8jr4"};